import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Empower citizens with real-time governance data", "Support independent research and policy analysis", "Expand our network of civic advocacy tools", "Drive transparency in public administration"];
export default function CampusVisitInvitation() {
  return <section data-section-id="225122" id="donate-introduction" className="bg-background text-foreground py-24 relative">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="relative -mt-12 lg:-mt-32 z-10 order-2 lg:order-1 flex justify-center lg:justify-end">
            <img src="https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/56348491-c11d-49d4-badc-fc5441054087.png" alt="Community meeting showing the real-world impact of CAN's data" className="w-full max-w-md lg:max-w-full h-auto object-contain drop-shadow-none border-b-4 border-primary" />
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col items-start pt-8 lg:pt-0">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-8 tracking-tight">Donation Portal Coming Soon!</h2>
            
            <ul className="space-y-5 mb-10 w-full">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <CircleCheck className="text-primary size-6 shrink-0 mt-0.5" />
                  <span className="text-lg text-muted-foreground font-default leading-relaxed">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <Button variant="outline" size="lg" className="border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300 text-base px-8 h-12 rounded-sm" asChild>
              
            </Button>
          </div>

        </div>
      </div>
    </section>;
}